import css from "../pdf.module.scss";

interface GridItemProps {
  title: string;
  value: string | number;
}

const GridItem = (props: GridItemProps): JSX.Element => {
  return (
    <div className="row ">
      <div className={css["title-grid"] + " col-5"}>{props.title}</div>
      <div className={css["title-grid-value"] + " col"}>
        {props.value ?? "N/A"}
      </div>
    </div>
  );
};

export default GridItem;
